<template>
	<ui-form :model="params.data" :transfer-model.sync="submitData" v-slot="{data}">
		<ui-hidden v-model="data.id" autosubmit/>
		<ui-select v-model="data.gradeId" label="年级" url="/admin/grade/list?page=1&limit=100" value-field="id" text-field="name"/>
		<ui-text v-model="data.title" label="诗名"/>
		<ui-text v-model="data.author" label="作者"/>
		<ui-text v-model="data.list" label="内容"/>
		<ui-text v-model="data.translation" label="释义"/>
		<ui-template>
			<ui-button type="submit" @submit="submit"></ui-button>
			<ui-button type="reset" v-if="params.type=='add'"></ui-button>
		</ui-template>
	</ui-form>
</template>

<script>
export default {
	props:['params','close'],
	data(){
		return {
			submitData:{}
		};
	},
	methods:{
		submit(){
			this.$axios.request({url:'/admin/poetry/option',data:this.submitData,method:this.params.type})
			.then(data=>{
				this.close();
			}).end();
		},
	},
}
</script>

<style>
</style>
